module.exports = __webpack_public_path__ + "static/media/test.371db4b8.png";